import { OrganizationRosterEntrySource } from '@/analytics/enums/organization.enums'

export type OrganizationRosterLocationState = {
  openOrganizationRoster?: boolean
  organizationRosterEntrySource?: string
}

export function organizationRosterLocationState(source: OrganizationRosterEntrySource): OrganizationRosterLocationState {
  return { openOrganizationRoster: true, organizationRosterEntrySource: source }
}

export function isOrganizationRosterRequested(state: unknown): boolean {
  return Boolean(state && typeof state === 'object' && 'openOrganizationRoster' in state && state.openOrganizationRoster === true)
}

export function organizationRosterEntrySourceFromState(state: unknown): string | null {
  if (!state || typeof state !== 'object' || !('organizationRosterEntrySource' in state)) return null
  const value = (state as OrganizationRosterLocationState).organizationRosterEntrySource
  return typeof value === 'string' ? value : null
}
